import Typography from "@material-ui/core/Typography";
import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AdGroupsDashboard from "../components/AdGroupsDashboard";
import NoAdGroupsFound from "../components/NoAdgroupsFound";
import TabPanel from "../../../../components/elements/TabPanel";
import classes from "../AdGroupSelectionSlide.module.scss";
import { AdGroupTemplate, AdGroupType } from "../../../../types/adGroupTypes";
import { PageStepComponentProps } from "../../../../components/modules/BaseStepper/BaseStepper";
import { ReduxApplicationState } from "../../../../types/ReduxTypes/ReduxApplicationState";
import { getAdGroupTemplates } from "../../../../redux/reducers/campaignToCreate";

type SelectSavedAdGroupTabProps = {
  selectedTabPanelValue: number;
};

const SelectSavedAdGroupTab: FC<PageStepComponentProps & SelectSavedAdGroupTabProps> = ({
  isAttemptingToGoNext,
  setIsAttemptingToGoNext,
  handleNext,
  selectedTabPanelValue,
}) => {
  const selectedAdvertiser = useSelector((state: ReduxApplicationState) => state.campaignToCreate.selectedAdvertiser)!;
  const adGroupTemplates = useSelector((state: ReduxApplicationState) => state.campaignToCreate.adGroupTemplates);
  const isVideoCampaign = useSelector(
    (state: ReduxApplicationState) => state.campaignToCreate.basicDetails.isVideoCampaign,
  );

  const isAdGroupsPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);
  const [filteredAdGroupsTemplates, setFilteredAdGroupsTemplates] = useState<AdGroupTemplate[]>([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTabPanelValue === 0 && adGroupTemplates.length === 0 && selectedAdvertiser) {
      dispatch(getAdGroupTemplates(selectedAdvertiser.brandgenAdvertiserId));
    }
  }, [adGroupTemplates.length, dispatch, selectedAdvertiser, selectedTabPanelValue]);

  useEffect(() => {
    if (!setIsAttemptingToGoNext && selectedAdvertiser) {
      dispatch(getAdGroupTemplates(selectedAdvertiser.brandgenAdvertiserId));
    }
  }, [dispatch, selectedAdvertiser, setIsAttemptingToGoNext]);

  useEffect(() => {
    setFilteredAdGroupsTemplates(
      adGroupTemplates.filter((adGroupTemplate) =>
        isVideoCampaign
          ? adGroupTemplate.adGroupType === AdGroupType.VIDEO
          : adGroupTemplate.adGroupType === AdGroupType.IMAGE,
      ),
    );
  }, [isVideoCampaign, adGroupTemplates]);

  return (
    <TabPanel
      value={selectedTabPanelValue}
      index={0}
      id="adGroup-selection-tabpanel"
      ariaLabelledBy="adGroup-selection-tab"
    >
      {isAdGroupsPending ? (
        <Typography className={classes.loaderLabel}>Please, wait while we get everything in order...</Typography>
      ) : !isAdGroupsPending && adGroupTemplates.length === 0 ? (
        <NoAdGroupsFound selectedAdvertiser={selectedAdvertiser} />
      ) : (
        <AdGroupsDashboard
          selectedAdvertiser={selectedAdvertiser}
          adGroupTemplates={filteredAdGroupsTemplates}
          isAttemptingToGoNext={isAttemptingToGoNext}
          setIsAttemptingToGoNext={setIsAttemptingToGoNext}
          handleNext={handleNext}
          showCheckbox={!!handleNext}
        />
      )}
    </TabPanel>
  );
};

export default SelectSavedAdGroupTab;
